module.exports = __webpack_public_path__ + "img/KSC03881.82e6412a.jpg";